// extracted by mini-css-extract-plugin
export var dropdown = "_vg-0";
export var imageWrapper = "_vg-3";
export var itemNameContainer = "_vg-1";
export var productImage = "_vg-2";
export var spinnerWrapper = "_vg-4";